import none from '../../img/kandokLogo.jpg'
export const cake =[
 {
  "id": 91,
  "title": "شکلاتی",
  "price": 70,
  "image": none
 },
 {
  "id": 92,
  "title": "ردولوت (قرمز)",
  "price": 70,
  "image": none
 },
 {
  "id": 93,
  "title": "هویج",
  "price": 70,
  "image": none
 },
 {
  "id": 94,
  "title": "تیرامیسو",
  "price": 80,
  "image": none
 }
]